<form (ngSubmit)="submitInvitation()" [class.vertical]="addPlaceholderToTeam" [formGroup]="invitationForm"
  class="invitation-box">
  <div class="image d-none d-sm-flex">
    <img alt="Einladung" aria-hidden="true"
      i18n-alt="Alt text@@invitationForm.imageAltInvitation" src="/assets/images/illustration-14.svg">
    </div>
    <div class="content">
      <div class="flex-row">
        <div>
          @if (addPlaceholderToTeam) {
            <h3 i18n="@@invitationForm.forTeam.title">Empfehlen Sie uns weiter!</h3>
          }
          @if (!addPlaceholderToTeam) {
            <h3 i18n="@@invitationForm.forPeople.title">Kennen Sie interessierte
                    Leute?</h3>
          }
          @if (addPlaceholderToTeam) {
            <p i18n="@@invitationForm.forTeam.content">Laden Sie bisherige persönliche
                    Assistentinnen und Assistenten oder Freunde und Familie zur CléA Assistenzplattform ein.</p>
          }
          @if (!addPlaceholderToTeam) {
            <p i18n="@@invitationForm.forPeople.content">Laden Sie Freunde und Familie
                    ein, bei der CléA Assistenzplattform mitzumachen.</p>
          }
        </div>
        <div class="image d-sm-none">
          <img alt="" aria-hidden="true" src="/assets/images/illustration-06.svg">
        </div>
      </div>
      @if ((isLoading$ | async) === false && !invited) {
        <div class="form-group">
          <label class="label" for="invitation-email" i18n="@@invitationForm.email">E-Mail</label>
          <input [formControl]="email" class="input" id="invitation-email" type="email"/>
          @if (email.invalid && email.touched) {
            <div class="validation error"
              i18n="@@invitationForm.email.invalidFormat">
                Bitte geben Sie eine gültige E-Mail Adresse ein.
            </div>
          }
        </div>
      }
      <app-spinner [visible]="isLoading$ | async"></app-spinner>
      @if (invited) {
        <p class="invited" i18n="@@invitationForm.invitationHasBeenSent">Die Einladung wurde
            verschickt.</p>
      }
    </div>
    @if ((isLoading$ | async) === false && !invited) {
      <div class="form-group actions">
        <button [disabled]="isLoading$ | async" class="button secondary block" i18n="@@invitationForm.btn.send"
          type="submit">Einladung versenden
        </button>
      </div>
    }
  </form>
